import type { LeadWithValuation } from '@/types'

export const LEAD_COLUMNS = [
  { key: 'date', header: 'Data', width: 22 },
  { key: 'firstName', header: 'Nome', width: 18 },
  { key: 'lastName', header: 'Cognome', width: 18 },
  { key: 'email', header: 'Email', width: 30 },
  { key: 'phone', header: 'Telefono', width: 18 },
  { key: 'status', header: 'Stato', width: 14 },
  { key: 'address', header: 'Indirizzo', width: 30 },
  { key: 'propertyType', header: 'Tipo', width: 14 },
  { key: 'area', header: 'Superficie', width: 12 },
  { key: 'estimatedValue', header: 'Valore Stimato', width: 18 },
  { key: 'pricePerSqm', header: 'Prezzo/mq', width: 14 },
  { key: 'zone', header: 'Zona', width: 20 },
  { key: 'gdpr', header: 'GDPR', width: 8 },
  { key: 'marketing', header: 'Marketing', width: 10 },
  { key: 'notes', header: 'Note', width: 30 },
] as const

export const STATUS_LABELS: Record<string, string> = {
  new: 'Nuovo',
  contacted: 'Contattato',
  callback: 'Da richiamare',
  acquired: 'Acquisito',
}

export function formatDateIT(dateString: string): string {
  return new Date(dateString).toLocaleString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function leadToRow(lead: LeadWithValuation): string[] {
  return [
    formatDateIT(lead.created_at),
    lead.first_name || '',
    lead.last_name || '',
    lead.email,
    lead.phone || '',
    STATUS_LABELS[lead.status] || lead.status,
    lead.valuation?.address || '',
    lead.valuation?.property_type || '',
    lead.valuation?.area?.toString() || '',
    lead.valuation?.estimated_value?.toString() || '',
    lead.valuation?.price_per_sqm?.toString() || '',
    lead.valuation?.zone_name_csv || '',
    lead.gdpr_consent ? 'Sì' : 'No',
    lead.marketing_consent ? 'Sì' : 'No',
    (lead.notes || '').replace(/;/g, ',').replace(/\n/g, ' '),
  ]
}

export function exportFileName(prefix: string, extension: string): string {
  const date = new Date().toISOString().split('T')[0]
  return `${prefix}_sanremo_${date}.${extension}`
}

export function downloadBlob(blob: Blob, filename: string) {
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = filename
  link.click()
  URL.revokeObjectURL(link.href)
}
